<!--CC: extracted from integrations.component.html -> LDAP content panel + popup-->
<div class="flex-column f-1-0 overflow-auto gap-4">

	<!--CC: connect/disconnect section-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;" [ngClass]="isConnected() ? 'text-success' : 'text-warning'">{{isConnected() ? 'Connected' : 'Disconnected'}}</span>
			<span style="font-size: 12px; max-width: 300px;">{{isConnected() ? 'Your LDAP server is now integrated with ' + gs.corpname : 'Allow us to establish a secure connection to your LDAP server.'}}</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;"
				   endIcon="far fa-plug"
				   [loading]="integrationActionInProcess"
				   (action)="connectToLdap();">
				{{isConnected() ? 'Disconnect' : 'Connect'}}
			</btn-c>
		</div>
	</div>

	<!--CC: connection details table-->
	<div class="flex-row gap-4" *ngIf="isConnected()">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Connection details</span>
		</div>
		<div class="w-50">
			<table class="simpleDataTableShrink middle">
				<tr>
					<td><b>Username:&nbsp;</b></td>
					<td><span>{{planInfo?.integrations.ldap.username}}</span></td>
				</tr>
				<tr>
					<td><b>Endpoint:&nbsp;</b></td>
					<td><span>{{planInfo?.integrations.ldap.endpoint}}</span></td>
				</tr>
				<tr>
					<td><b>Base DN:&nbsp;</b></td>
					<td><span>{{planInfo?.integrations.ldap.baseDN}}</span></td>
				</tr>
			</table>
		</div>
	</div>

	<!--CC: groups/aliases section-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Groups/Aliases</span>
			<span style="font-size: 12px; max-width: 300px;">Knowing your groups/aliases will allow us to protect you better</span>
		</div>
		<div class="w-50 flxRow" style="flex-wrap: wrap; align-items: flex-start;">
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   endIcon="far fa-users"
				   (action)="getGroups(true);">
				Show Groups
			</btn-c>
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   endIcon="far fa-users"
				   (action)="getMailboxesAliases(true);">
				Show Aliases
			</btn-c>
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   [loading]="integrationActionInProcess"
				   endIcon="{{integImportGroupsSummary ? 'far fa-sync': 'far fa-users-cog'}}"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   (action)="integImportGroups();">
				{{integImportGroupsSummary ? 'Update ': 'Sync'}}
			</btn-c>
		</div>
	</div>
</div>

<groups-popup-c *ngIf="showGroups"
				(cancelCb)="getGroups(false)"
				popupTitle="Groups"
				[showActions]="true">
</groups-popup-c>

<aliases-popup-c *ngIf="showAliases"
				 (cancelCb)="getMailboxesAliases(false)"
				 popupTitle="Aliases"
				 [showActions]="true">
</aliases-popup-c>

<!--CC: LDAP connect popup-->
<popup-c *ngIf="ldapConnectPopup?.show"
		 head="Connect to LDAP" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="ldapConnectPopup = null;"
		 (confirmCb)="connectLdapExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !ldapConnectPopup.ldapUsername || !ldapConnectPopup.ldapPassword || !ldapConnectPopup.ldapEndpoint || !ldapConnectPopup.ldapBaseDN || !ldapConnectPopup.ldapPort,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Username:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="ldapConnectPopup.ldapUsername">
				</td>
			</tr>
			<tr>
				<td><b>Password:&nbsp;</b></td>
				<td>
					<div class="flxRow-start">
						<input style="width:100%; margin: 0;"
							   type="text"
							   [(ngModel)]="ldapConnectPopup.ldapPassword"
							   [ngClass]="{'nofill': ldapConnectPopup.ldapPassword && !showPassword}">
						<label style="opacity: 0.2; display: flex; cursor: pointer; align-items: center; margin: 0 0 0 -20px;" class="hidepwd">
							<input type="checkbox" [(ngModel)]="showPassword"/>
							<i class="fas fa-eye unchecked"></i>
							<i class="fas fa-eye-slash checked"></i>
						</label>
					</div>
				</td>
			</tr>
			<tr>
				<td><b>Base DN:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="ldapConnectPopup.ldapBaseDN">
				</td>
			</tr>
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="ldapConnectPopup.ldapEndpoint">
				</td>
			</tr>
			<tr>
				<td><b>Port:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="number"
						   [(ngModel)]="ldapConnectPopup.ldapPort">
				</td>
			</tr>
		</table>
		<br/>
		<checkbox id="securedConnectionOnly" [(model)]="ldapConnectPopup.ldapSecure">
			Allow secure connection only
		</checkbox>
		<br/>
		<div class="ip-allowlist-section">
			<span>*Allowlist the following IPs in your firewall policy:</span>
			<div class="ip-list">
				<code class="ip-address" title="Click to copy">3.221.25.19</code>,
				<code class="ip-address" title="Click to copy">35.172.145.174</code>,
				<code class="ip-address" title="Click to copy">44.209.231.3</code>,
				<code class="ip-address" title="Click to copy">34.192.117.166</code>,
			</div>
		</div>
	</div>
</popup-c>
